'use client';

import {searchParamsFromProductConfiguration} from '@/modules/commerce/product/configuration';

import type {ProductFilters} from '../../filters/query';
import ProductCardBase from '../ProductCardBase';
import {PRODUCT_PAGE_ALL_SLUG} from '../schema/constants';

import {
	getCabShoeTrayConfigurationAppropriateForFilters,
	getConfiguredCabShoeTrayProductBrands,
} from './filtering';
import type {CabShoeTrayProductFragment} from './query';

export type CabShoeTrayProductCardProps = {
	product: CabShoeTrayProductFragment;
	headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
	filters?: ProductFilters;
};

export default function CabShoeTrayProductCard({
	product,
	headingLevel = 2,
	filters,
}: CabShoeTrayProductCardProps) {
	const configuration = getCabShoeTrayConfigurationAppropriateForFilters(product, filters);
	const params = searchParamsFromProductConfiguration(configuration);

	const brands = getConfiguredCabShoeTrayProductBrands(product, configuration);
	const href = `/${PRODUCT_PAGE_ALL_SLUG}/${product.fullSlug}?${params.toString()}`;

	return (
		<ProductCardBase
			href={href}
			product={product}
			configuration={configuration}
			headingLevel={headingLevel}
			brands={brands}
			isConfigurable
		/>
	);
}
